import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { toast } from 'react-toastify';

const deleteCategory = (id: number) => api.delete(`/categories/${id}`);

export const useDeleteCategoryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['delete-category'],
    mutationFn: deleteCategory,
    onSuccess: () => {
      toast.success('Category deleted successfully');

      queryClient.invalidateQueries({
        queryKey: ['categories'],
      });
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
